import { getEnvVariable } from "../../../../modules/environmentalList";




export const getColor = () => {
    let module = getEnvVariable('ModuleKey')
    switch (module) {
        case 'UPS':
            return 'rgba(0, 71, 133)'
        case 'LAOACS':
            return '#293352'
        default:
            return '#007bff';
    }
}




